<template>
  <section class="section-content">
    <div class="back-button" @click="goToHome">
      <svg xmlns="http://www.w3.org/2000/svg" width="7" height="15" viewBox="0 0 7 15" fill="none">
        <path d="M6 0.500122L1 7.50012L6 14.5001" stroke="#464D5B" />
      </svg>
      <span class="back-text">Programas</span>
    </div>
    <div class="separator-line mobile"></div>
    <div class="title-container mobile">
      <span class="program-title ">PROGRAMAS</span>
    </div>
    <div class="search-container desktop">
      <div class="search-bar-cnt">
        <section class="search-bar">
          <input v-model="searchValue" type="text" class="search-input" placeholder="Buscar programa" />
          <div class="search-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="36" viewBox="0 0 35 36" fill="none">
              <mask id="mask0_1448_2585" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="35"
                height="36">
                <rect y="0.500122" width="35" height="35" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_1448_2585)">
                <path
                  d="M28.8488 30.872L19.7705 21.7934C19.0478 22.3901 18.2166 22.8571 17.2771 23.1944C16.3376 23.5316 15.3657 23.7003 14.3613 23.7003C11.8909 23.7003 9.80007 22.845 8.08893 21.1343C6.37779 19.4237 5.52222 17.3334 5.52222 14.8634C5.52222 12.3937 6.37755 10.3027 8.0882 8.5904C9.79886 6.87832 11.8892 6.02228 14.3592 6.02228C16.8289 6.02228 18.92 6.87783 20.6323 8.58895C22.3444 10.3001 23.2005 12.3908 23.2005 14.8613C23.2005 15.8935 23.0273 16.8794 22.6808 17.8189C22.3342 18.7584 21.8718 19.5756 21.2936 20.2703L30.3719 29.3485L28.8488 30.872ZM14.3613 21.5325C16.2238 21.5325 17.8012 20.8862 19.0937 19.5935C20.3863 18.3011 21.0327 16.7237 21.0327 14.8613C21.0327 12.9989 20.3863 11.4215 19.0937 10.129C17.8012 8.83635 16.2238 8.19002 14.3613 8.19002C12.4989 8.19002 10.9215 8.83635 9.62902 10.129C8.33633 11.4215 7.68999 12.9989 7.68999 14.8613C7.68999 16.7237 8.33633 18.3011 9.62902 19.5935C10.9215 20.8862 12.4989 21.5325 14.3613 21.5325Z"
                  fill="url(#paint0_linear_1448_2585)" />
              </g>
              <defs>
                <linearGradient id="paint0_linear_1448_2585" x1="5.52222" y1="18.4471" x2="30.3719" y2="18.4471"
                  gradientUnits="userSpaceOnUse">
                  <stop offset="0.23516" stop-color="#4536EF" />
                  <stop offset="0.913242" stop-color="#FF00B8" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </section>
      </div>
      <div class="search-details desktop">
        <span class="search-info">Mostrando todos los programas</span>
        <span class="search-info">{{ programs.totalAllProducts }} programas encontrados</span>
      </div>
    </div>
    <div class="content-wrapper">
      <div class="left-section ">
        <div class="below-search ">
          <h2 class="main-title desktop">Más relevantes</h2>
          <p class="description">
            Programas con objetivos específicos
            y menú de alimentación por nutriólogas,
            basados en la metodología Umana.
          </p>
          <div class="search-bar-cnt-mobile mobile">
            <section class="search-bar-mobile">
              <input v-model="searchValue" type="text" class="search-input-mobile" placeholder="Buscar programa" />
              <div class="search-icon-mobile"><svg xmlns="http://www.w3.org/2000/svg" width="35" height="36"
                  viewBox="0 0 35 36" fill="none">
                  <mask id="mask0_1168_2160" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="35"
                    height="36">
                    <rect y="0.5" width="35" height="35" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_1168_2160)">
                    <path
                      d="M28.8486 30.8719L19.7702 21.7934C19.0475 22.3901 18.2164 22.8571 17.2769 23.1943C16.3374 23.5316 15.3654 23.7002 14.3611 23.7002C11.8906 23.7002 9.79982 22.8449 8.08868 21.1343C6.37754 19.4236 5.52197 17.3333 5.52197 14.8634C5.52197 12.3937 6.3773 10.3027 8.08796 8.59034C9.79862 6.87826 11.8889 6.02222 14.3589 6.02222C16.8287 6.02222 18.9197 6.87777 20.6321 8.58889C22.3442 10.3 23.2002 12.3908 23.2002 14.8612C23.2002 15.8935 23.027 16.8794 22.6806 17.8189C22.3339 18.7584 21.8715 19.5755 21.2933 20.2703L30.3717 29.3485L28.8486 30.8719ZM14.3611 21.5325C16.2235 21.5325 17.801 20.8861 19.0934 19.5935C20.3861 18.301 21.0324 16.7236 21.0324 14.8612C21.0324 12.9988 20.3861 11.4214 19.0934 10.129C17.801 8.83629 16.2235 8.18996 14.3611 8.18996C12.4987 8.18996 10.9212 8.83629 9.62878 10.129C8.33609 11.4214 7.68975 12.9988 7.68975 14.8612C7.68975 16.7236 8.33609 18.301 9.62878 19.5935C10.9212 20.8861 12.4987 21.5325 14.3611 21.5325Z"
                      fill="url(#paint0_linear_1168_2160)" />
                  </g>
                  <defs>
                    <linearGradient id="paint0_linear_1168_2160" x1="5.52197" y1="18.4471" x2="30.3717" y2="18.4471"
                      gradientUnits="userSpaceOnUse">
                      <stop offset="0.23516" stop-color="#4536EF" />
                      <stop offset="0.913242" stop-color="#FF00B8" />
                    </linearGradient>
                  </defs>
                </svg></div>
            </section>
          </div>
          <div class="button-container">
            <button class="custom-button" :class="{ 'gradient-button': !collabs }" @click="collabs = !collabs">
              <span>Todos los programas</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="16" viewBox="0 0 7 16" fill="none">
                <path d="M1 15.0001L6 8.00012L1 1.00012" stroke="#B359F8" stroke-width="1.5" stroke-linecap="round" />
              </svg>
            </button>
          </div>
          <div class="button-container">
            <button class="custom-button" :class="{ 'gradient-button': collabs }" @click="collabs = !collabs">
              <div class="text-svg">
                <span class="button-content">Collabs</span>
                <svg class="text-svg" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                  fill="none">
                  <mask id="mask0_1448_2965" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16"
                    height="17">
                    <rect y="0.00012207" width="16" height="16" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_1448_2965)">
                    <path
                      d="M0.633333 8.86679C0.433333 8.46679 0.277778 8.06123 0.166667 7.65012C0.0555556 7.23901 0 6.82234 0 6.40012C0 5.15568 0.422222 4.11123 1.26667 3.26679C2.11111 2.42234 3.15556 2.00012 4.4 2.00012C5.1 2.00012 5.76667 2.14734 6.4 2.44179C7.03333 2.73623 7.56667 3.14457 8 3.66679C8.43333 3.14457 8.96667 2.73623 9.6 2.44179C10.2333 2.14734 10.9 2.00012 11.6 2.00012C12.8444 2.00012 13.8889 2.42234 14.7333 3.26679C15.5778 4.11123 16 5.15568 16 6.40012C16 6.82234 15.9444 7.23901 15.8333 7.65012C15.7222 8.06123 15.5667 8.46679 15.3667 8.86679C15.2444 8.65568 15.1 8.46679 14.9333 8.30012C14.7667 8.13346 14.5722 8.00012 14.35 7.90012C14.45 7.64457 14.5278 7.39457 14.5833 7.15012C14.6389 6.90568 14.6667 6.65568 14.6667 6.40012C14.6667 5.53346 14.3722 4.80568 13.7833 4.21679C13.1944 3.6279 12.4667 3.33346 11.6 3.33346C10.7 3.33346 10.0083 3.58068 9.525 4.07512C9.04167 4.56957 8.53333 5.12234 8 5.73346C7.46667 5.11123 6.95833 4.55568 6.475 4.06679C5.99167 3.5779 5.3 3.33346 4.4 3.33346C3.53333 3.33346 2.80556 3.6279 2.21667 4.21679C1.62778 4.80568 1.33333 5.53346 1.33333 6.40012C1.33333 6.65568 1.36111 6.90568 1.41667 7.15012C1.47222 7.39457 1.55 7.64457 1.65 7.90012C1.42778 8.00012 1.23333 8.13346 1.06667 8.30012C0.9 8.46679 0.755556 8.65568 0.633333 8.86679ZM0 14.6668V13.6168C0 13.1279 0.247222 12.7362 0.741667 12.4418C1.23611 12.1473 1.87778 12.0001 2.66667 12.0001C2.81111 12.0001 2.95 12.0029 3.08333 12.0085C3.21667 12.014 3.34444 12.0279 3.46667 12.0501C3.31111 12.2723 3.19444 12.5112 3.11667 12.7668C3.03889 13.0223 3 13.2946 3 13.5835V14.6668H0ZM4 14.6668V13.5835C4 12.8612 4.36944 12.2779 5.10833 11.8335C5.84722 11.389 6.81111 11.1668 8 11.1668C9.2 11.1668 10.1667 11.389 10.9 11.8335C11.6333 12.2779 12 12.8612 12 13.5835V14.6668H4ZM13 14.6668V13.5835C13 13.2946 12.9639 13.0223 12.8917 12.7668C12.8194 12.5112 12.7111 12.2723 12.5667 12.0501C12.6889 12.0279 12.8139 12.014 12.9417 12.0085C13.0694 12.0029 13.2 12.0001 13.3333 12.0001C14.1333 12.0001 14.7778 12.1473 15.2667 12.4418C15.7556 12.7362 16 13.1279 16 13.6168V14.6668H13ZM8 12.5001C7.36667 12.5001 6.8 12.5835 6.3 12.7501C5.8 12.9168 5.50556 13.1112 5.41667 13.3335H10.6C10.5 13.1112 10.2028 12.9168 9.70833 12.7501C9.21389 12.5835 8.64444 12.5001 8 12.5001ZM2.66667 11.3335C2.3 11.3335 1.98611 11.2029 1.725 10.9418C1.46389 10.6807 1.33333 10.3668 1.33333 10.0001C1.33333 9.62234 1.46389 9.30568 1.725 9.05012C1.98611 8.79457 2.3 8.66679 2.66667 8.66679C3.04444 8.66679 3.36111 8.79457 3.61667 9.05012C3.87222 9.30568 4 9.62234 4 10.0001C4 10.3668 3.87222 10.6807 3.61667 10.9418C3.36111 11.2029 3.04444 11.3335 2.66667 11.3335ZM13.3333 11.3335C12.9667 11.3335 12.6528 11.2029 12.3917 10.9418C12.1306 10.6807 12 10.3668 12 10.0001C12 9.62234 12.1306 9.30568 12.3917 9.05012C12.6528 8.79457 12.9667 8.66679 13.3333 8.66679C13.7111 8.66679 14.0278 8.79457 14.2833 9.05012C14.5389 9.30568 14.6667 9.62234 14.6667 10.0001C14.6667 10.3668 14.5389 10.6807 14.2833 10.9418C14.0278 11.2029 13.7111 11.3335 13.3333 11.3335ZM8 10.6668C7.44444 10.6668 6.97222 10.4723 6.58333 10.0835C6.19444 9.69457 6 9.22234 6 8.66679C6 8.10012 6.19444 7.62512 6.58333 7.24179C6.97222 6.85846 7.44444 6.66679 8 6.66679C8.56667 6.66679 9.04167 6.85846 9.425 7.24179C9.80833 7.62512 10 8.10012 10 8.66679C10 9.22234 9.80833 9.69457 9.425 10.0835C9.04167 10.4723 8.56667 10.6668 8 10.6668ZM8 8.00012C7.81111 8.00012 7.65278 8.06401 7.525 8.19179C7.39722 8.31957 7.33333 8.4779 7.33333 8.66679C7.33333 8.85568 7.39722 9.01401 7.525 9.14179C7.65278 9.26957 7.81111 9.33346 8 9.33346C8.18889 9.33346 8.34722 9.26957 8.475 9.14179C8.60278 9.01401 8.66667 8.85568 8.66667 8.66679C8.66667 8.4779 8.60278 8.31957 8.475 8.19179C8.34722 8.06401 8.18889 8.00012 8 8.00012Z"
                      fill="white" />
                  </g>
                </svg>
              </div>

              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="16" viewBox="0 0 7 16" fill="none">
                <path d="M1 15.0001L6 8.00012L1 1.00012" stroke="white" stroke-width="1.5" stroke-linecap="round" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div class="right-section">
        <div class="section-container">
          <h3 v-if="!collabs" class="class-title">Más recientes</h3> 
          <!-- Si quieres añadir o cambiar los programas que salen en mas recientes tienes que quitarles o añadirle la etiqueta de relevantes -->
          <section v-if="!collabs" class="cards-wrapper">
            <cardClass v-for="(item, index) in relevantes.data" :key="index" :program="item" :section="'relevantes'" />
          </section>
          <h3 class="class-title">Últimas colaboraciones</h3>
          <section class="cards-wrapper">
            <cardClass v-for="(item, index) in colaboraciones.data" :key="index" :program="item"
              :section="'colaboraciones'" />
          </section>

          <h3 v-if="!collabs" class="class-title">Todos los programas</h3>
          <section v-if="!collabs" class="cards-wrapper">
            <cardClass v-for="(item, index) in programs.data" :key="index" :program="item" :section="'todos'" />
          </section>
        </div>
      </div>
    </div>





    <div v-if="regLoading" class="loaderView">
      <div>
        <div class="loaderSpinner"></div>
        <p class="process">{{ process }}</p>
      </div>
    </div>
    <notificacion :tipo="toastType" :titulo="toastTitle" :text="toastSub" :state="toastState" />


  </section>
</template>

<script>
import { mapActions } from "vuex";
import cardClass from "../cardClass.vue";
import searchBar from "../searchBar.vue";
import Notificacion from "@/components/utils/notificacion.vue";
export default {
  components: {
    cardClass,
    searchBar,
    Notificacion
  },
  data() {
    return {
      searchValue: '',
      toastType: '',
      toastTitle: '',
      toastSub: '',
      toastState: false,
      regLoading: false,
      process: "",
      collabs: false,
    };
  },
  async created() {
    await this.getIdentity()

    this.regLoading = true
    this.process = "CARGANDO programas"
    await this.updateAll()
    this.regLoading = false

  },
  computed: {
    identity() {
      return this.$store.getters['admin/getIdentity'];
    },
    programs() {
      const paginated = structuredClone(this.$store.getters['program/data']);
      if (this.searchValue !== '') {
        const filtered = []
        for (const item of paginated.data) {
          if (this.includesItem(this.searchValue, item.title)) {
            filtered.push(item)
          }
        }

        return {
          totalAllProducts: paginated.totalAllProducts,
          totalPages: paginated.totalPages,
          page: paginated.page,
          pageSize: paginated.pageSize,
          quantity: filtered.length,
          data: filtered
        }
      }

      return paginated
    },
    relevantes() {
      const paginated = structuredClone(this.$store.getters['programrel/data']);
      if (this.searchValue !== '') {
        const filtered = []
        for (const item of paginated.data) {
          if (this.includesItem(this.searchValue, item.title)) {
            filtered.push(item)
          }
        }

        return {
          totalAllProducts: paginated.totalAllProducts,
          totalPages: paginated.totalPages,
          page: paginated.page,
          pageSize: paginated.pageSize,
          quantity: filtered.length,
          data: filtered
        }
      }

      return paginated
    },
    colaboraciones() {
      const paginated = structuredClone(this.$store.getters['programcollabs/data']);
      if (this.searchValue !== '') {
        const filtered = []
        for (const item of paginated.data) {
          if (this.includesItem(this.searchValue, item.title)) {
            filtered.push(item)
          }
        }

        return {
          totalAllProducts: paginated.totalAllProducts,
          totalPages: paginated.totalPages,
          page: paginated.page,
          pageSize: paginated.pageSize,
          quantity: filtered.length,
          data: filtered
        }
      }

      return paginated
    },
  },
  methods: {
    ...mapActions("program", ["getAllInfoPgr"]),
    ...mapActions("programcollabs", ["getAllInfoPgrc"]),
    ...mapActions("programrel", ["getAllInfoPgrr"]),

    includesItem(search, name) {
      name = name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      if (search == '') {
        return true
      }
      name = name.toLowerCase()
      search = search.toLowerCase()
      if (search == '') {
        return false;
      }
      return name.includes(search)
    },

    async updateAll() {
      await this.getAllInfoPgr("program/paginated?pageSize=100") //pendiente paginar y filtrar
      await this.getAllInfoPgrc("program/paginated?pageSize=100&categories=42") //pendiente paginar y filtrar
      await this.getAllInfoPgrr("program/paginated?pageSize=100&categories=41") //pendiente paginar y filtrar
    },

    goToHome() {
      this.$router.push({ query: { a: "inicio" } });
    },

    setNoti(toastState, toastType, toastTitle, toastSub) {
      this.toastState = toastState
      this.toastType = toastType
      this.toastTitle = toastTitle
      this.toastSub = toastSub
      setTimeout(() => {
        this.clearToast();
      }, 5000);
    },
    clearToast() {
      this.toastState = false
    },
    getIdentity: async function () {
      const response = await this.$store.dispatch("admin/getData");
      return response
    },


  },
};
</script>

<style scoped>
.desktop {
  display: block;
}

.mobile {
  display: none;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.section-content {
  padding: 0;
}

.main-title,
.description,
.class-title {
  margin-top: 0;
}

.search-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  margin-bottom: 1vw;
}

.search-bar-cnt {
  flex: 1;
  width: 26.0833vw;
}

.search-details {
  display: flex;
  gap: 17.3611vw;
  white-space: nowrap;
}

.search-info {
  color: var(--Text, #464d5b);
  font-family: Manrope, sans-serif;
  font-size: 0.9vw;
  font-weight: 600;
  line-height: normal;
}

.button-container {
  width: 100%;
}

.gradient-button {
  display: flex;
  height: 2.5vw;
  padding: 0.5vw 1vw;
  justify-content: space-between;
  align-items: center;
  border-radius: 20vw;
  background: linear-gradient(90deg, #4536ef 23.52%, #ff00b8 91.32%);
  border: none !important;
  color: #fff;
  font-family: Manrope, sans-serif;
  font-size: 1vw;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
}

.button-content {
  display: flex;
  align-items: center;
  gap: 0.5vw;
}

.gradient-button .button-content {
  color: #fff;
  text-align: center;
  font-family: Manrope;
  font-size: 1vw;
  font-weight: 400;
  line-height: normal;
}

.text-svg {
  display: flex;
  flex-direction: row;
  gap: 0.5vw;
}

.gradient-button .text-svg {
  display: flex;
  flex-direction: row;
  stroke: none;
  width: 1vw;
  height: 1vw;
}

.gradient-button svg {
  flex-shrink: 0;
  stroke: #fff;
}

.custom-button {
  width: 100%;
  display: flex;
  padding: 0.5vw 1vw;
  justify-content: space-between;
  align-items: center;
  border-radius: 20vw;
  border: 0.07vw solid var(--Text, #464d5b);
  background-color: transparent;
  cursor: pointer;
}

.custom-button span {
  color: var(--Text, #464d5b);
  text-align: center;
  font-family: Manrope;
  font-size: 1vw;
  font-weight: 400;
  line-height: normal;
}

.gradient-button span {
  color: #fff !important;
}

.custom-button svg {
  width: 0.5vw;
  height: 1vw;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 0.5vw;
  cursor: pointer;
  margin-bottom: 0.5vw;
}

.back-text {
  font-family: Manrope;
  font-size: 1.2vw;
  font-weight: 600;
  color: var(--Text, #464d5b);
}

.back-icon {
  width: 0.5vw;
  height: 1vw;
  stroke: var(--Text, #464d5b);
}

.content-wrapper {
  display: flex;
  gap: 2vw;
  margin-top: 0;
  justify-content: space-between;
  align-items: flex-start;
}

.left-section {
  width: 30%;
  display: flex;
  flex-direction: column;
  gap: 1vw;
  position: sticky;
  top: 6.9444vw;
}

.below-search {
  display: flex;
  flex-direction: column;
  gap: 1.5vw;
}

.main-title {
  color: var(--Text, #464d5b);
  font-family: Manrope, sans-serif;
  font-size: 1.7vw;
  font-weight: 400;
  line-height: normal;
  margin-top: 0;
}

.description {
  width: 100%;
  color: var(--Text, #464d5b);
  font-family: Manrope, sans-serif;
  font-size: 1vw;
  font-weight: 400;
  line-height: normal;
  margin-top: 0;
}

.right-section {
  width: 70%;
  display: flex;
  flex-direction: column;
}

.section-container {
  width: 100%;
}

.class-title {
  margin: 0;
  text-align: left;
  color: var(--Text, #464d5b);
  font-family: Manrope;
  font-size: 1.2vw;
  font-weight: 500;
  line-height: normal;
  padding-left: 0.5vw;
  margin-top: 1vw;
}

.cards-wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1vw;
  padding: 1vw 0;
}



.search-bar {
  display: flex;
  width: 23.9583vw;
  height: 3.4722vw;
  padding: 0.2778vw 1.0417vw;
  justify-content: space-between;
  align-items: center;
  border-radius: 20.8333vw;
  border: 0.0694vw solid var(--background-gray, #e3e3e9);
  background-color: white;
}

.search-input {
  border: none;
  outline: none;
  width: 100%;
  font-family: Inter, sans-serif;
  font-size: 1.0417vw;
  font-weight: 300;
  color: var(--Text, #464d5b);
}

.search-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.4306vw;
  height: 2.4306vw;
  flex-shrink: 0;
}

@media (max-width: 530px) {
  .desktop {
    display: none;
  }

  .mobile {
    display: block;
  }

  .back-text {
    flex-grow: 1;
    font-size: 4.5vw;
    text-align: center;
  }

  .back-button {
    padding-bottom: 5vw;
  }

  .back-button svg {
    width: 2.25vw;
    height: auto;
  }

  .separator-line {
    width: 100%;
    height: 0.0694vw;
    min-height: 0.0694vw;
    background: #e3e3e9;
  }

  .program-title {
    align-self: stretch;
    font-family: Kemio;
    font-size: 16.25vw;
    font-style: normal;
    font-weight: 400;
    line-height: 80%;
    text-transform: uppercase;
    background: var(--gradient-2, linear-gradient(90deg, #4536EF 23.52%, #FF00B8 91.32%));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .title-container {
    padding-top: 5vw;
  }

  .left-section {
    width: 100%;
    position: relative;
  }

  .description {
    font-size: 4.25vw;
  }

  .gradient-button {
    height: 10vw;
    padding: 2.5vw 5vw;
    border-radius: 75vw;
  }

  .custom-button {
    height: 10vw;
    padding: 2.5vw 5vw;
    border-radius: 75vw;
  }

  .custom-button span {
    font-size: 3.5vw;
  }

  .custom-button svg {
    width: 1.25vw;
    height: 3.5vw;
  }

  .gradient-button .button-content {
    font-size: 3.5vw;
  }

  .gradient-button .text-svg {
    width: 4vw;
    height: 4vw;
    flex-shrink: 0;
  }

  .right-section {
    padding-top: 12.5vw;
    padding-bottom: 10vh;
    width: 100%;
  }


  .content-wrapper {
    display: flex;
    flex-direction: column;
  }

  .cards-wrapper {
    gap: 2.5vw;
    grid-template-columns: repeat(2, 1fr);
  }

  .class-title {
    font-size: 5vw;
  }

  .search-bar-cnt-mobile {
    flex: 1;
    width: 100%;
    padding-bottom: 5vw;
  }

  .search-bar-mobile {
    display: flex;
    width: 100%;
    height: 10vw;
    padding: 2.2727vw;
    justify-content: space-between;
    align-items: center;
    border-radius: 20.8333vw;
    border: 0.0694vw solid var(--background-gray, #e3e3e9);
    background-color: white;
  }

  .search-input-mobile {
    border: none;
    outline: none;
    width: 100%;
    font-family: Inter, sans-serif;
    font-size: 3.4091vw;
    font-weight: 300;
    color: var(--Text, #464d5b);
    ;
  }

  .search-icon-mobile {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 7.9545vw;
    height: 7.9545vw;
    flex-shrink: 0;
  }
}
</style>
